module.exports = __webpack_public_path__ + "img/halteknop02.34e61747.png";